var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad5" },
    _vm._l(_vm.socios, function(item, index) {
      return item.pessoa && _vm.socios && _vm.socios.length > 0
        ? _c(
            "app-collapse",
            {
              key: item._id,
              attrs: { title: item.pessoa.pessoaFisica.nome, collapsed: "1" }
            },
            [
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("Função:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.getFuncao(
                          item.funcao,
                          item.isSocioRepresentanteLegal
                        )
                      )
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("Nome:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " + _vm._s(_vm.filterNull(item.pessoa.pessoaFisica.nome))
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("CPF:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " + _vm._s(_vm.filterNull(item.pessoa.pessoaFisica.cpf))
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("RG:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " + _vm._s(_vm.filterNull(item.pessoa.pessoaFisica.rg))
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Órgão expedidor:")
                ]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.filterNull(
                          item.pessoa.pessoaFisica.orgaoExpedidor.codigo
                        )
                      )
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("UF do RG:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        item.pessoa.pessoaFisica.orgaoExpedidor.estado || "-"
                      )
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Nacionalidade:")
                ]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.filterNull(item.pessoa.pessoaFisica.nacionalidade)
                      )
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("Estado civil:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.estadoCivilFormatado(
                          item.pessoa.pessoaFisica.estadoCivil
                        )
                      )
                  )
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("Email:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v("  " + _vm._s(_vm.filterNull(item.pessoa.email)))
                ])
              ]),
              _c("app-resumo-documentos", {
                attrs: { documentos: item.documentos }
              })
            ],
            1
          )
        : _vm._e()
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b6e21b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b6e21b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoSocios.vue
// module id = null
// module chunks = 